import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('invitecode/list', { params });
  },
  async logs(params: any) {
    return axios.get('invitecode/logs', { params });
  },
  async send(params: any) {
    return axios.post('invitecode/send', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('invitecode/detail', { params });
  },
  async edit(params: any) {
    return axios.post('invitecode/edit', qs.stringify(params));
  }
};
